import { Document, Page, Text, View, Image, Font } from "@react-pdf/renderer";
import sitlogo from '../../assets/images/sitlogo.png'

const Convocation_Guest_List_Report = ({ data }) => {
  Font.register({
    family: 'Poppins',
    fonts: [
      {
        src: '/fonts/Poppins-Regular.ttf',
        fontWeight: 'normal',
      },
      {
        src: '/fonts/Poppins-SemiBold.ttf',
        fontWeight: 600,
      },
      {
        src: '/fonts/Poppins-Bold.ttf',
        fontWeight: 'bold',
      },
    ],
  });

  function formatDate(dateInput) {
    const date = new Date(dateInput);
    const day = String(date.getDate()).padStart(2, '0');        // dd
    const month = String(date.getMonth() + 1).padStart(2, '0'); // mm (months are 0-indexed)
    const year = date.getFullYear();                            // yyyy

    return `${day}-${month}-${year}`;
  }

  const studentList = Array.isArray(data) ? data : [];

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={{ padding: 30, fontSize: 10 }}>
        {/* Logo View */}
        <View style={{ flexDirection: "column", alignItems: "flex-start" }}>
          <Image src={sitlogo} style={{ width: 60 }} />
        </View>

        {/* Title View */}
        <View
          style={{
            width: "100%",
            padding: 5,
            fontFamily: "Poppins",
            fontWeight: 600,
            fontSize: 12,
            borderWidth: 1.5,
            border: "none",
            borderColor: "black",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <Text style={{ fontSize: 10 }}>CONVOCATION GUEST LIST :</Text>
          <Text style={{ fontSize: 10, marginLeft: 10 }}>Year to Year</Text>
        </View>

        {/* Content View */}
        <View
          style={{
            width: "100%",
            border: "1.5px solid black",
            flexDirection: "column",
          }}
        >
          {/* Header Row */}
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              borderBottom: "1.5px solid black",
            }}
          >
            {[
              { label: "Date", width: "7%" },
              { label: "Day", width: "8%" },
              { label: "Course_Name", width: "20%" },
              { label: "Batch", width: "6%" },
              { label: "Faculty Name", width: "15%" },
              { label: "Guest Name", width: "16%" },
              { label: "Mobile No", width: "12%" },
              { label: "Email Id", width: "18%" },
            ].map((col, i) => (
              <View
                key={i}
                style={{
                  width: col.width,
                  borderRight: i < 7 ? "1.5px solid black" : "none",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text style={{ fontSize: 8, fontFamily: "Poppins", fontWeight: 600 }}>{col.label}</Text>
              </View>
            ))}
          </View>

          {/* Dynamic Rows */}
          {studentList.map((item, index) => (
            <View
              key={index}
              style={{
                width: "100%",
                flexDirection: "row",
                borderBottom: "1.5px solid black",
              }}
            >
              <View style={{ width: "7%", borderRight: "1.5px solid black", justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 8.5, fontFamily: "Poppins", fontWeight: 600 }}>{formatDate(item.DateAdded)}</Text>
              </View>
              <View style={{ width: "8%", borderRight: "1.5px solid black", justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 8.5, fontFamily: "Poppins", fontWeight: 600 }}>{item.Days}</Text>
              </View>
              <View style={{ width: "20%", borderRight: "1.5px solid black", justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 8.5, fontFamily: "Poppins", fontWeight: 600 }}>{item.Course_Name}</Text>
              </View>
              <View style={{ width: "6%", borderRight: "1.5px solid black", justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 8.5, fontFamily: "Poppins", fontWeight: 600 }}>{item.Batch_Code}</Text>
              </View>
              <View style={{ width: "15%", borderRight: "1.5px solid black", justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 8.5, fontFamily: "Poppins", fontWeight: 600 }}>{item.FName}</Text>
              </View>
              <View style={{ width: "16%", borderRight: "1.5px solid black", justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 8.5, fontFamily: "Poppins", fontWeight: 600 }}>{item.GName}</Text>
              </View>
              <View style={{ width: "12%", borderRight: "1.5px solid black", justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 8.5, fontFamily: "Poppins", fontWeight: 600 }}>{item.Mobile_no}</Text>
              </View>
              <View style={{ width: "18%", justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 8.5, fontFamily: "Poppins", fontWeight: 600 }}>{item.Email_id}</Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );

}

export default Convocation_Guest_List_Report